import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function AdminLogin() {
    const { email, login } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: "admin@coteperdue.fr", password: "" });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    if (email) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(form.email, form.password);
            navigate("/admin");
        } catch {
            setError("Identifiants incorrects.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-cp-ivoire flex items-center justify-center px-6" data-testid="admin-login-page">
            <div className="max-w-md w-full">
                <p className="cp-kicker text-cp-foret mb-6">Administration</p>
                <h1 className="cp-serif text-5xl md:text-6xl leading-tight text-cp-noir mb-10">
                    Côte Perdue<br />— éditorial.
                </h1>
                <form onSubmit={submit} className="flex flex-col gap-6" data-testid="admin-login-form">
                    <input type="email" required placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="cp-input" data-testid="admin-login-email" />
                    <input type="password" required placeholder="Mot de passe" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="cp-input" data-testid="admin-login-password" />
                    <button type="submit" disabled={loading} className="cp-btn-primary mt-4" data-testid="admin-login-submit">
                        {loading ? "Connexion…" : "Se connecter"}
                    </button>
                    {error && <p className="text-red-600 text-sm" data-testid="admin-login-error">{error}</p>}
                </form>
            </div>
        </div>
    );
}
